export const useCallbackReportColumns = () => {
  return [
    {
      field: 'timestamp',
      headerName: 'Time stamp ',
      flex: 1,
    },
    {
      field: 'group',
      headerName: 'Group',
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'User',
      flex: 1,
    },
    {
      field: 'time_to_fill',
      headerName: 'Time to fill',
      flex: 1,
    },
    {
      field: 'create_name',
      headerName: 'Accepted By',
      flex: 1,
    },
  ];
};

export default useCallbackReportColumns;
